import assetVisitService from '@satellite/services/asset-visit-service';
import useNotify from './useNotify';
import { useI18n } from 'vue-i18n';

export default function useAssetVisit() {
  const notify = useNotify();
  const { t } = useI18n();

  const updateAssetVisit = async (id, payload) => {
    try {
      const assetVisit = await assetVisitService.updateAssetVisit(id, payload);

      if (assetVisit?.id) {
        notify(t('assetVisit.common.messages.updateSuccess'), 'success');
      }

      return assetVisit;
    } catch (error) {
      notify(t('assetVisit.common.messages.updateError'), 'error');
      throw error;
    }
  };

  return {
    updateAssetVisit
  };
}
